import React, { useState, useEffect } from "react";
import { Image } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import DeleteModal from "../../../../CommonComponent/DeleteModal/DeleteModal";
import { SectionAddModal } from "pages/AppraisalManagment/AppraisalSetup/AppraisalForm/component";
import Columns from "./component/Columns/Columns";
import DataTable from "CommonComponent/DataTable/DataTable";
import { Header } from "./component";
import { fetchSections, getSectionById, deleteSection } from "actions";
import { F } from "pages/AppraisalManagment/constants/legacyApiKeys";
import AccessRights from "utils/AccessRights";

const SectionList = () => {
  const dispatch = useDispatch();
  const sectionState = useSelector((state) => state.sectionState);
  const session = useSelector((state) => state.session);

  const object_viewed_id = session?.current_page_permissions?.object_id || session?.current_object_viewed_id || "";
  const canAdd = AccessRights(session?.current_page_permissions, "add");

  const [deleteModalShow, setDeleteModalShow] = useState(false);
  const [addModalShow, setAddModalShow] = useState(false);
  const [editModalShow, setEditModalShow] = useState(false);
  const [viewModalShow, setViewModalShow] = useState(false);
  const [editSectionData, setEditSectionData] = useState(null);
  const [deleteTarget, setDeleteTarget] = useState(null);

  // Fetch sections on component mount
  useEffect(() => {
    dispatch(fetchSections(object_viewed_id));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Refresh list after successful create/update/delete
  useEffect(() => {
    if (sectionState.redirectToList) {
      dispatch(fetchSections(object_viewed_id));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sectionState.redirectToList]);

  // Handlers
  const handleViewSection = (sectionId) => {
    dispatch(getSectionById(sectionId, "view"));
    setViewModalShow(true);
  };

  const handleEditSection = (sectionId) => {
    dispatch(getSectionById(sectionId, "update"));
    setEditSectionData({ id: sectionId });
    setEditModalShow(true);
  };

  // Reset modals when they close
  const handleAddModalClose = () => {
    setAddModalShow(false);
  };

  const handleEditModalClose = () => {
    setEditModalShow(false);
    setEditSectionData(null);
  };

  const handleViewModalClose = () => {
    setViewModalShow(false);
  };

  const handleDeleteSection = () => {
    if (deleteTarget) {
      dispatch(deleteSection(deleteTarget));
      setDeleteModalShow(false);
      setDeleteTarget(null);
    }
  };

  // Columns helpers
  const getName = (row) => row.title || row[F.legacyNameSynonym] || "";
  const getActions = (row) => {
    const currentPermissions = session?.current_page_permissions;
    const canView = AccessRights(currentPermissions, "view", row.created_by);
    const canEdit =
      row.is_deleted === "n" && AccessRights(currentPermissions, "edit", row.created_by);
    const canDelete =
      row.is_deleted === "n" && AccessRights(currentPermissions, "delete", row.created_by);

    return (
      <div className="section-actions">
        {canView ? (
          <Image
            src="/assets/images/view-icon.svg"
            width={20}
            style={{ cursor: "pointer" }}
            className="me-2"
            title="View"
            onClick={() => handleViewSection(row.id)}
          />
        ) : null}
        {canEdit ? (
          <Image
            src="/assets/images/edit-icon.svg"
            width={20}
            style={{ cursor: "pointer" }}
            className="me-2"
            title="Edit"
            onClick={() => handleEditSection(row.id)}
          />
        ) : null}
        {canDelete ? (
          <Image
            src="/assets/images/delete-icon.svg"
            width={20}
            style={{ cursor: "pointer" }}
            title="Delete"
            onClick={() => {
              setDeleteTarget(row.id);
              setDeleteModalShow(true);
            }}
          />
        ) : null}
      </div>
    );
  };

  const columns = Columns({
    getName,
    getActions,
    session,
  });

  // Use data from Redux store
  const rows = sectionState.sectionsList || [];

  return (
    <>
      <Header onAddClick={() => setAddModalShow(true)} canAdd={canAdd} />

      <div className="main-content-div">
        <DataTable
          columns={columns}
          data={rows}
          serverSide={false}
        />

        {/* Delete Modal */}
        <DeleteModal
          show={deleteModalShow}
          onDelete={handleDeleteSection}
          onHide={() => setDeleteModalShow(false)}
          handleModalOpen={setDeleteModalShow}
          handleClose={() => setDeleteModalShow(false)}
        />

        {/* Add Section Modal */}
        <SectionAddModal
          show={addModalShow}
          onHide={handleAddModalClose}
          mode="add"
        />

        {/* Edit Section Modal */}
        <SectionAddModal
          show={editModalShow}
          onHide={handleEditModalClose}
          mode="edit"
        />

        {/* View Section Modal */}
        <SectionAddModal
          show={viewModalShow}
          onHide={handleViewModalClose}
          mode="view"
        />
      </div>
    </>
  );
};

export default SectionList;